import { useContext, useEffect } from 'react';
import { MyContext } from '../Context/MyProvider';
import secureLocalStorage from 'react-secure-storage';

const AllPayment = ({ Amount, url }) => {

    const { HandleCallApi, setPaymentLoading, setIsToast, setToastMsg } = useContext(MyContext);

    useEffect(() => {
        handleGetURl();
    }, [Amount]);

    const handleGetURl = async () => {
        const uid = secureLocalStorage.getItem("Userid");
        const Response = await HandleCallApi("Post", url, { uid, amount: Amount, status: 2 });
        if (Response.data.Result == true) {
            window.location.href = Response.data.PaymentURL;
        } else {
            setIsToast(true);
            setToastMsg(Response.data.message);
        }
        setPaymentLoading(false);
    }

    return null;
}

export default AllPayment